import React, { useMemo, useEffect, useState } from "react";
import Loader from "../../components/Loader";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import { useSelector } from "react-redux";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import {
  extractDate,
  extractDateFromStr,
  getLatestUpdatedObject,
} from "../../Utils/utils";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import usePagination from "../../hooks/usePagination";
import Pagination from "../../components/Pagination/Pagination";
import TenderSearch from "../../components/TenderSearch";
import { useTableResponsive } from "../../hooks/useTableResponsive";
import useSeo from "../../hooks/useSeo";
import { useLocation } from "react-router-dom";
import PdfZipItem from "../../components/PdfZipItem";

const ProcurementPlanPage = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredTenders, setFilteredTenders] = useState([]);
  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const {
    data: procurementPlanData = [],
    isLoading: procurementPlanIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "procurement_plan",
    lang: languageType,
  });

  useTableResponsive(procurementPlanData);

  const lastUpdatedOn = useMemo(() => {
    return extractDateFromStr(
      getLatestUpdatedObject(procurementPlanData)?.changed
    );
  }, [procurementPlanData]);

  useEffect(() => {
    if (searchTerm) {
      const filtered = procurementPlanData.filter((item) =>
        item.title.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredTenders(filtered);
    } else {
      setFilteredTenders(procurementPlanData);
    }
  }, [searchTerm, procurementPlanData]);

  const { currentItems, currentPage, totalPages, handlePageChange } =
    usePagination(filteredTenders, 12);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerImage, innerBannerTitle } = useSeo({ pathname });

  if (procurementPlanIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        title={getText("Tender", "निविदा")}
        titleLink="/tender/procurement-plan"
        levelTwo={true}
        levelThree={false}
        bannerImage={innerBannerImage}
        titleTwo={innerBannerTitle}
        isActive={innerBannerTitle}
      />

      <div className="inner-container">
        <div className="container">
          <div className="container">
            {/* <PageLastUpdated lastUpdatedOn={lastUpdatedOn} /> */}

            <div className="row">
              <div className="col-12 col-md-6 col-lg-6 mb-3 d-flex justify-content-between">
                <TenderSearch
                  setSearchTerm={setSearchTerm}
                  title={"Tender Number"}
                />
              </div>
              <div className="col-12 col-md-6 col-lg-6 mb-3 d-flex justify-content-end">
                <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="table-responsive">
                  <table className="table table-striped custom-table">
                    <thead className="thead-dark">
                      <tr>
                        <th>{getText("S.No.", "क्र. सं.")}</th>
                        <th>{getText("Detail", "विवरण ")}</th>
                        <th>{getText("Document", "दस्तावेज़ ")}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {currentItems.map((item, index) => (
                        <tr key={index}>
                          <td data-key={getText("S.No.", "क्र. सं.")}>
                            {index + 1}
                          </td>
                          <td data-key={getText("Detail", "विवरण ")}>
                            {item.title}
                          </td>
                          <td data-key={getText("Document", "दस्तावेज़ ")}>
                            <PdfZipItem
                              filePath={item?.field_procurement_plan_document}
                              filesize={item.filesize_1}
                            />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <Pagination
                    currentPage={currentPage}
                    totalPages={totalPages}
                    onPageChange={handlePageChange}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ProcurementPlanPage;
